import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const IdentificationTypeRoutes = [
  {
    path: '/identification-types',
    name: 'ListIdentificationTypes',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'identification_type:list'
    }
  },
  {
    path: '/identification-type/',
    name: 'CreateIdentificationType',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'identification_type:create'
    }
  },
  {
    path: '/identification-type/:id',
    name: 'UpdateIdentificationType',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'identification_type:update'
    }
  },
  {
    path: '/identification-type/view/:id',
    name: 'GetIdentificationType',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'identification_type:get'
    }
  }
]
